import React from 'react'
import { useState } from 'react';
import Header from '../components/Header'
import "../components/styles/Epuja.css"
import basuru_img from "../assets/CTA/Basuri2 1.jpg";
import Epujaicon from "../assets/Epuja/Ellipse 1.jpg";
import Footer from '../components/Footer';

import { toast, ToastContainer } from "react-toastify";
import BookPanditForm from "../components/BookPanditForm";
import BookPanditPopupModal
from "../components/BookPanditPopupModal";


const Epuja = () => {
      const [isMobile, setIsMobile] = useState(false);
  return (
    <>
      <Header />
      <div className="Epuja align-items-center text-center d-flex flex-column justify-content-center p-5 mt-5">
        {/* <img src={Epujabanner} alt="" /> */}
        <h3>Ez Puja Path - Your Trusted </h3>
        <h1>ePuja Partner</h1>
        <p>
          Experience hassle-free puja services <br></br>
          from the comfort of your home!
        </p>
        <div className="d-flex  justify-content-center gap-2">
          <h2> <a   onClick={() => {

    window.dispatchEvent(
      new CustomEvent(
        "openBookPanditModal"
      )
    );

  }}style={{ textDecoration: 'none', color: 'white' , cursor: "pointer", }} target="_blank" rel="noopener noreferrer">Book a pandit</a>
          </h2>
          <h2> <a   style={{ textDecoration: 'none', color: 'white' }} target="_blank" rel="noopener noreferrer">Call Now</a>
          </h2>
        </div>
      </div>
      <div className=" ">
        <div className="container">
          <div className="row   ">
            <div className="col-lg-6 col-12 text-center align-content-center " style={{ color: "white" }}>
              <div className="Epuja_card1 text-start p-3">
                <h1 className="m-2">How It Works?</h1>
                <div className=" Epuja_card1_container m-2 p-3">
                  <h2>Simple Steps to Book Your Puja</h2>
                  <p>
                    1. Choose Your Puja – Select from our wide range of puja
                    services. <br></br>
                    2. Fill in Details – Provide your name, date, and location.{" "}
                    <br></br>
                    3. Select Mode – Choose between Online or In-Person Puja.{" "}
                    <br></br>
                    4. Make Payment – Complete payment securely. <br></br>
                    5. Get Confirmation – Receive all details via email or
                    WhatsApp.
                  </p>
                </div>
                <div className=" text-dark m-2 p-3"><p style={{color:'black'}}>
                ✨ Authenticity & Trust ✨ Convenience & Flexibility ✨
                  Affordable & Transparent Pricing ✨ Verified & Experienced
                  Pandits
                </p>
                 
                </div>
              </div>
              <div className="Epuja_card2 text-start p-3">
                <h1 className="m-2">Online e-Puja Service</h1>
                <div className="Epuja_card2_container m-2 p-3">
                  <h2>100% Free Consultation With Ez Puja Path</h2>
                  {/* <div className="Epuja_card2_container2 d-flex p-2 gap-1 text-center align-items-center mt-4 mb-4">
                    <select
                      class="form-select w-25 countryy"
                      aria-label="Default select example">
                      <option selected>India (+91)</option>
                      <option value="1">India (+91)</option>
                      <option value="2">India (+91)</option>
                      <option value="3">India (+91)</option>
                    </select>
                    <input
                      type="number"
                      name=""
                      id=""
                      placeholder="Phone Number"
                      className="w-50 p-2 rounded-1 border-0"
                    />
                    <h1
                      className=" p-1 rounded-1 mt-2 w-25 countryy"
                      style={{ backgroundColor: "white", fontSize: '18px' }}>
                      Book Now
                    </h1>
                  </div> */}
                  <div
                    className="d-flex  justify-content-between text-center align-items-center flex-wrap"
                    style={{ color: "#6B2A00", gap: '12px' }}>
                    <div>
                      <img src={Epujaicon} alt="" />
                      <p>Yahan vaiva and occasion</p>
                    </div>
                    <div>
                      <img src={Epujaicon} alt="" />
                      <p>Yahan vaiva and occasion</p>
                    </div>
                    <div>
                      <img src={Epujaicon} alt="" />
                      <p>Yahan vaiva and occasion</p>
                    </div>
                    <div>
                      <img src={Epujaicon} alt="" />
                      <p>Yahan vaiva and occasion</p>
                    </div>

                  </div>
                </div>
                <h1>Booking Process</h1>
                <p className="Epuja_card2_container3_p2">
                  Please provide your details to book a puja seamlessly:
                </p>
                <div className="Epuja_card2_container3_p">
                  <p>Your Name:</p>
                  <p>Mobile Number :-</p>
                  <p>Email Address :-</p>
                  <p>Puja Name:</p>
                  <p>Date:</p>
                  <p>City and State:</p>
                </div>
                <h1>Payment & Confirmation</h1>
                <p className="Epuja_card2_container3_p2">
                  You can complete the payment after the successful completion
                  of the puja through any convenient method. Once your booking
                  details are submitted, we will confirm via email or WhatsApp,
                  connecting you with <strong>Ez Puja Path.</strong>{" "}
                </p>
                <h1>Additional Arrangements</h1>
                <p className="Epuja_card2_container3_p2">
                  For puja-related items, arrangements can be discussed with
                  <strong> Ez Puja Path.</strong> The total cost may vary based
                  on your requirements.{" "}
                </p>
                <p className="Epuja_card2_container3_p2">
                  📞 Call us at: +91 1234567890 <br></br>
                  💬 WhatsApp us at: +91 1234567890
                </p>
                <strong style={{ color: "#000", fontSize: "16px" }}>
                  Ez Puja Path – Hassle-Free Puja Services, Anytime, Anywhere!
                </strong>
              </div>
              <div className="Epuja_card3 text-start p-3">
                <h1 className="m-2">Book Your Puja Now!</h1>
                <div className="m-2 p-4">
                  🌟 Ez Puja Path – Hassle-Free Puja Services, Anytime,
                  Anywhere!
                </div>
                <button className=" m-2 me-2">Call Now</button>
              </div>
              <div className="Epuja_card4 text-start p-3">
                <h1 className="m-2">
                  E-Puja Services – Experience Divine Blessings from Anywhere
                </h1>
                <div className="m-2 p-4">
                  <h2>Why Choose Ez Puja Path?</h2>
                  <p>
                    At Ez Puja Path, we bring the sacred rituals of puja to your
                    home, no matter where you are. Our expert Vedic pandits
                    perform traditional Hindu rituals with authenticity,
                    ensuring a seamless spiritual experience for you and your
                    family.
                  </p>
                </div>
                <h3 className="m-2">
                  <strong>✅ 100% Free Consultation – </strong> Get guidance on
                  the right puja for your needs. <br></br>
                  <br></br>
                  <strong>✅ Certified & Experienced Pandits – </strong> We
                  connect you with verified Vedic scholars.<br></br>
                  <br></br>
                  <strong>✅ Customized Puja Services – </strong> Choose
                  language, rituals, and preferences.<br></br>
                  <br></br>
                  <strong>✅ Complete Samagri Arrangements – </strong> We
                  provide all required puja items.<br></br>
                  <br></br>
                  <strong>✅ Virtual & In-Person Puja Options – </strong>{" "}
                  Experience divine rituals at your convenience.<br></br>
                  <br></br>
                </h3>
              </div>
              <div className="Epuja_card5 text-start p-3">
                <div>
                  <h1 className="m-2">Daily & Special Puja Services</h1>
                  <ul className=" d-flex justify-content-between flex-wrap gap-3">
                    <li>Ganesh Puja</li>
                    <li> Lakshmi Puja</li>
                    <li>Rudrabhishek</li>
                    <li>Navgraha Shanti</li>
                  </ul>
                </div>
                <div>
                  <h1 className="m-2">Festival & Vrat Puja</h1>
                  <ul className=" d-flex justify-content-between flex-wrap gap-3">
                    <li>Diwali Puja</li>
                    <li> Karva Chauth Vrat Katha</li>
                    <li>Chhath Puja</li>
                    <li>Makar Sankranti</li>
                  </ul>
                </div>
                <div>
                  <h1 className="m-2">Home & Business Pujas</h1>
                  <ul className=" d-flex justify-content-between flex-wrap gap-3">
                    <li>Griha Pravesh</li>
                    <li> Vastu Shanti</li>
                    <li>Navratri Puja</li>
                    <li>Office Opening</li>
                  </ul>
                </div>
                <div>
                  <h1 className="m-2">Dosha & Remedies Puja</h1>
                  <ul className=" d-flex justify-content-between flex-wrap gap-3">
                    <li>Kaal Sarp Dosha Nivaran</li>
                    <li> Pitra Dosha</li>
                    <li>Manglik Dosha</li>
                    <li>Shani Puja</li>
                  </ul>
                </div>
                <div>
                  <h1 className="m-2">Astrology & Consultation</h1>
                  <ul className=" d-flex justify-content-between flex-wrap gap-3">
                    <li>Kundali Matching</li>
                    <li> Vedic Astrology Guidance</li>
                    <li>Muhurat Consultation</li>

                  </ul>
                </div>
              </div>
            </div>


         


            <div className="col-lg-6 ctapart2 align-items-center mt-4 mb-3 col-12" style={{ position: 'sticky', top: '113px', }}>
 
    
    
            <BookPanditForm />
            <ToastContainer />
    

              </div>



              
          </div>
        </div>
      </div>
      <Footer />
      <BookPanditPopupModal />
    </>
  )
}

export default Epuja